import { useState, useEffect } from "react";
import { DepotDropDown } from "src/components/DepotDropdown";
import { ClientDropDown } from "src/components/ClientDropdown";
import { ProjectDropDown } from "src/components/ProjectDropdown";
import { CalenderDropdown } from "src/components/CalenderDropdown";
import { getAllGoodsInData1, setAllFilterDataToRedux } from "src/thunks/goodsin";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { getAllGoodsInData } from "src/thunks/goodsin";
import moment from "moment";
import SigmaLogo from "src/assets/images/S1GMA_Logo.svg";
import { getAllDispatchOrderData } from "src/thunks/dispatchOrder";
import { toast } from "react-toastify";
import { getAllItemInventoryData, getAllReconcileData, getAllReportsData } from "src/thunks/reports";
import { GetError } from "src/constant";
import { MonthAndYearDropdown } from "src/components/monthAndYearDropdown/dropdown";
import IconClearFilter from "src/assets/images/icon_clearfilter.svg";
import IconRefreshList from "src/assets/images/icon_refreshlist.svg";
import _ from "lodash";
import { TypeDropDown } from "src/components/InternalAndExternalDropdown";

function GoodsInHeader({ props, RightSidebarOpenCloseFlag }) {
  let userDetails = JSON.parse(localStorage.getItem("userDetails"));

  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const allDeportsdata = useSelector(
    (state) => state?.depotUsers?.depoData || []
  );
  const { signoutModelOpenFlag } = useSelector((state) => state.auth);

  const { filterAllData } = useSelector((state) => state.goodsin);

  const [YearArrayToDisplay, setYearArrayToDisplay] = useState([]);

  const [filterData, setFilterData] = useState({});

  const lookupValues = useSelector((state) => state.lookup);

  let filterDataForLookop = _.find(lookupValues?.data, (d) => d?.typeName === "ItemStorageType")

  const ComponentName =
    pathname === "/app/goodsin/list"
      ? "goodsIn"
      : pathname === "/app/dispatchorders/list"
        ? "dispatch" :
        pathname === "/app/iteminventoryreport/list" ? "Inventrory" :
          pathname === "/app/reconciliation/list" ? "Reconsilition" : "report";

  useEffect(() => {
    if (Object.keys(filterAllData).length > 0) {
      setFilterData(filterAllData[`${ComponentName}`]);
    }
  }, [ComponentName]);

  const allFilterChange = (label, value) => {
    let changeData = {
      ...filterData,
      [label]: value,
      type: "Monthly",
    };
    if (label === "checked" && value) {
      changeData["toDate"] = new Date();
    } else if (label === "checked" && !value) {
      delete changeData["toDate"];
    }

    if (label === "clientId") {
      delete changeData["projectId"];
    }

    setFilterData({ ...changeData });
  };

  let monthData = [
    { name: "JAN", id: 1 },
    { name: "FEB", id: 2 },
    { name: "MAR", id: 3 },
    { name: "APR", id: 4 },
    { name: "MAY", id: 5 },
    { name: "JUN", id: 6 },
    { name: "JUL", id: 7 },
    { name: "AUG", id: 8 },
    { name: "SEP", id: 9 },
    { name: "OCT", id: 10 },
    { name: "NOV", id: 11 },
    { name: "DEC", id: 12 },
  ];

  useEffect(() => {
    let yearArrayDisplay = [];

    const minOffset = 0;
    const maxOffset = 25;
    const thisYear = new Date().getFullYear();

    for (let i = minOffset; i <= maxOffset; i++) {
      const year = thisYear - i;
      yearArrayDisplay = [...yearArrayDisplay, { id: year, name: year }];
    }
    setYearArrayToDisplay(yearArrayDisplay);
  }, []);

  const handleRefreshListButtonClick = async () => {
    try {
      const filterClone = _.cloneDeep(filterAllData);
      filterClone[`${ComponentName}`] = { ...filterData };
      dispatch(setAllFilterDataToRedux({ ...filterClone }));
      localStorage.setItem("filterAllData", JSON.stringify(filterClone));

      let data = {
        isDateRange: false,
        from: moment(filterData?.fromDate).format("YYYY-MM-DD"),
        DepotIds: [filterData?.depotId?.id || 0],
        ClientIds: [filterData?.clientId?.id || 0],
        ProjectIds: [filterData?.projectId?.id || 0],
      };
      if (filterData?.toDate) {
        data["to"] = moment(filterData?.toDate).format("YYYY-MM-DD");
        data["isDateRange"] = true;
      }
      if (pathname == "/app/reconciliation/list") {
        let data = {
          fromDate: moment(filterData?.fromDate).format("YYYY-MM-DD"),
          DepotIds: [filterData?.depotId?.id || 0],
          ClientIds: [filterData?.clientId?.id || 0],
          ProjectIds: [filterData?.projectId?.id || 0],
          spaceType: [filterData?.spaceType?.value || filterDataForLookop?.id || 0],
        };
        await dispatch(getAllReconcileData({ ...data })).unwrap();
      }
      else if (pathname == "/app/iteminventoryreport/list") {
        await dispatch(getAllItemInventoryData({ ...data })).unwrap();
      } else if (pathname == "/app/goodsin/list") {
        await dispatch(getAllGoodsInData1({ ...data })).unwrap();
      } else if (pathname == "/app/report/list") {
        let UrlData = {
          depotId: filterData?.depotId?.id || "0",
          clientId: filterData?.clientId?.id || "0",
          projectId: filterData?.projectId?.id || "0",
          month: filterData?.month || new Date().getMonth() + 1,
          year: filterData?.year || new Date().getFullYear(),
          type: "Monthly",
        };
        let reportResult = await dispatch(
          getAllReportsData({ ...UrlData })
        ).unwrap();
      }
      else {
        await dispatch(getAllDispatchOrderData({ ...data })).unwrap();
      }
    } catch (error) {
      toast.error(GetError(error?.response?.data?.errors) || "something issue");
    }
  };

  const handleClearFilterButtonClick = async () => {
    const filterClone = _.cloneDeep(filterAllData);
    filterClone[`${ComponentName}`] = {};
    dispatch(setAllFilterDataToRedux({ ...filterClone }));
    localStorage.setItem("filterAllData", JSON.stringify(filterClone));
    setFilterData({});

    try {
      let data = {
        isDateRange: false,
        from: moment().format("YYYY-MM-DD"),
        DepotIds: [0],
        ClientIds: [0],
        ProjectIds: [0],
      };
      if (pathname == "/app/goodsin/list") {
        await dispatch(getAllGoodsInData1({ ...data })).unwrap();
      } else if (pathname == "/app/report/list") {
        await dispatch(
          getAllReportsData({
            type: "Monthly",
            month: new Date().getMonth() + 1,
            year: new Date().getFullYear(),
            depotId: 0,
            clientId: 0,
            projectId: 0,
          })
        );
      } else if (pathname === "/app/iteminventoryreport/list") {
        let reportResult = await dispatch(
          getAllItemInventoryData({ ...data })
        ).unwrap();
      } if (pathname == "/app/reconciliation/list") {
        let data = {
          fromDate: moment().format("YYYY-MM-DD"),
          DepotIds: [0],
          ClientIds: [0],
          ProjectIds: [0],
          spaceType: [filterDataForLookop?.id || 0],
        };
        await dispatch(getAllReconcileData({ ...data })).unwrap();
      } else {
        await dispatch(getAllDispatchOrderData({ ...data })).unwrap();
      }
    } catch (error) {
      toast.error(GetError(error?.response?.data?.errors) || "something issue");
    }
  };

  const getYearComponent = () => {
    return (
      <div style={{ flex: 1, color: "white" }}>
        <MonthAndYearDropdown
          handleChange={(value) => allFilterChange("year", value)}
          shownDropdownValue={filterData?.year || new Date().getFullYear()}
          data={YearArrayToDisplay}
        />
      </div>
    );
  };

  const getMonthComponent = () => {
    let monthShown = _.find(
      monthData,
      (d) => d.id === parseInt(filterData?.month || new Date().getMonth() + 1)
    )?.name;
    return (
      <div style={{ flex: 1, color: "white" }}>
        <MonthAndYearDropdown
          handleChange={(value) => allFilterChange("month", value)}
          shownDropdownValue={monthShown}
          data={monthData}
        />
      </div>
    );
  };

  return (
    <>
      <div
        className={`${signoutModelOpenFlag == true ? "add-overlay-for-depot-dropdown" : ""
          }`}
        style={{
          display: "flex",
          alignItems: "center",
          flex: 10,
          height: 60,
          backgroundColor: "#0045d9",
        }}
      >
        <div style={{ height: "35px", width: "90px" }} className="ms-2">
          <img width={"100%"} height={"100%"} src={SigmaLogo} alt="muz image" />
        </div>
        <div
          className="d-flex goodsin-text-color text-uppercase"
          style={{
            flex: 2,
            color: "#FFFFFF",
            fontFamily: "Montserrat-Regular",
            fontSize: 15,
          }}
        >
          {pathname == "/app/report/list" ? (
            <>
              <div
                style={{
                  flex: 1,
                  color: "#FFFFFF",
                  fontFamily: "Montserrat-Regular",
                  fontSize: 15,
                }}
              >
                {getYearComponent()}
              </div>
              <div
                style={{
                  flex: 1,
                  color: "#FFFFFF",
                  fontFamily: "Montserrat-Regular",
                  fontSize: 15,
                }}
              >
                {getMonthComponent()}
              </div>
            </>
          ) : (
            <CalenderDropdown
              fromDate={moment(filterData?.fromDate || new Date()).format(
                "YYYY-MM-DD"
              )}
              toDate={
                filterData?.checked
                  ? moment(filterData?.toDate || new Date()).format(
                    "YYYY-MM-DD"
                  )
                  : null
              }
              isSingleDate={pathname == "/app/reconciliation/list" ? true : false}
              previousDateShownFlag={filterData?.checked || false}
              handleFromDate={(date) => allFilterChange("fromDate", date)}
              handleToDate={(date) => allFilterChange("toDate", date)}
              handlePreviousDateChange={(flag) =>
                allFilterChange("checked", flag)
              }
            />
          )}
        </div>
        <div
          className={
            userDetails?.roles == "DepotManager"
              ? "d-flex justify-content-center"
              : ""
          }
          style={{ flex: 2, color: "white" }}
        >
          <DepotDropDown
            depoDataShown={
              userDetails?.roles == "DepotManager"
                ? userDetails?.depots
                : allDeportsdata
            }
            handleChange={(value) => allFilterChange("depotId", value)}
            depotDashboardDropdownValue={
              filterData?.depotId || { id: 0, name: "ALL DEPOTS" }
            }
          />
        </div>
        <div style={{ flex: 2, color: "white" }}>
          <ClientDropDown
            handleChange={(value) => allFilterChange("clientId", value)}
            clientGoodsInDropdownValue={
              filterData?.clientId || { id: 0, name: "ALL CLIENTS" }
            }
          />
        </div>
        <div style={{ flex: 2, color: "white" }}>
          <ProjectDropDown
            clientId={filterData?.clientId}
            handleChange={(value) => allFilterChange("projectId", value)}
            projectGoodsInDropdownValue={
              filterData?.projectId || { id: 0, name: "ALL PROJECTS" }
            }
          />
        </div>
        {pathname === "/app/reconciliation/list" &&
          <div style={{ flex: 1, color: "white" }}>
            <TypeDropDown
              handleChange={(value) => allFilterChange("spaceType", value)}
              clientGoodsInDropdownValue={
                filterData?.spaceType || { id: filterDataForLookop?.id, name: filterDataForLookop?.name }
              }
            />
          </div>}
        <div
          onClick={handleClearFilterButtonClick}
          className="d-flex flex-column goodsin-text-color"
          style={{
            flex: 0.5,
            color: "#FFFFFF",
            fontSize: 9,
            fontFamily: "Montserrat-Regular",
            cursor: "pointer",
          }}
        >
          <img
            src={IconClearFilter}
            width={20}
            height={20}
            alt="clearfilters"
          />
          CLEAR FILTERS
        </div>
        <div
          onClick={handleRefreshListButtonClick}
          className="d-flex flex-column goodsin-text-color"
          style={{
            flex: 0.5,
            color: "#FFFFFF",
            fontFamily: "Montserrat-Regular",
            fontSize: 9,
            marginRight: 5,
            marginLeft: 5,
            cursor: "pointer",
          }}
        >
          <img
            src={IconRefreshList}
            width={20}
            height={20}
            alt="clearfilters"
          />
          REFRESH LIST
        </div>
      </div>
    </>
  );
}

export default GoodsInHeader;
